const STORAGE_KEY = 'assign-delivery-return';

export function extractEntregaIdFromQrText(text){
	const t = String(text).trim();
	const h = t.match(/assign-delivery\/([a-f0-9]{24})/i);
	if(h) return h[1];
	if(/^[a-f0-9]{24}$/i.test(t)) return t;
	return null;
}

export function setAssignDeliveryReturnPath(entregaId){
	const id = String(entregaId || '').trim();
	if(!/^[a-f0-9]{24}$/i.test(id)) return;
	sessionStorage.setItem(STORAGE_KEY, `/assign-delivery/${id}`);
}

export function consumeAssignDeliveryReturnPath(){
	const p = sessionStorage.getItem(STORAGE_KEY);
	if(p && /^\/assign-delivery\/[a-f0-9]{24}$/i.test(p)){
		sessionStorage.removeItem(STORAGE_KEY);
		return p;
	}
	if(p) sessionStorage.removeItem(STORAGE_KEY);
	return null;
}

export function clearAssignDeliveryReturnPath(){
	sessionStorage.removeItem(STORAGE_KEY);
}

const BATCH_DRAFT_KEY = 'assign-delivery-batch-draft';
const BATCH_DRAFT_MAX_AGE_MS = 4 * 60 * 60 * 1000;

export function saveAssignDeliveryBatchDraft(payload){
	const routeEntregaId = payload && payload.routeEntregaId;
	const lojaId = payload && payload.lojaId;
	if(!routeEntregaId || !lojaId || !payload.stops || !payload.stops.length) return;
	sessionStorage.setItem(BATCH_DRAFT_KEY, JSON.stringify({
		routeEntregaId,
		lojaId: String(lojaId),
		stops: payload.stops,
		entregadorId: payload.entregadorId || '',
		canAssign: !!payload.canAssign,
		ts: Date.now(),
	}));
}

export function loadAssignDeliveryBatchDraft(routeEntregaId){
	const raw = sessionStorage.getItem(BATCH_DRAFT_KEY);
	if(!raw) return null;
	let d;
	try {
		d = JSON.parse(raw);
	}catch(_e){
		sessionStorage.removeItem(BATCH_DRAFT_KEY);
		return null;
	}
	if(!d || !d.routeEntregaId){
		sessionStorage.removeItem(BATCH_DRAFT_KEY);
		return null;
	}
	if(d.routeEntregaId !== routeEntregaId){
		sessionStorage.removeItem(BATCH_DRAFT_KEY);
		return null;
	}
	if(Date.now() - (d.ts || 0) > BATCH_DRAFT_MAX_AGE_MS){
		sessionStorage.removeItem(BATCH_DRAFT_KEY);
		return null;
	}
	if(!Array.isArray(d.stops) || !d.stops.length) return null;
	return d;
}

export function clearAssignDeliveryBatchDraft(){
	sessionStorage.removeItem(BATCH_DRAFT_KEY);
}
